var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-poster-with-image',{attrs:{"headline":_vm.$t('referral.page.header', { reward: _vm.referralReward, class: 'blue' }),"src":"/img/posters/invitePoster.png","alt":_vm.$t('referral')}})}
var staticRenderFns = []

export { render, staticRenderFns }